import React from 'lib/react';
import {
  EVAlert, makeStyles, EVCheckCircleOutlineIcon, EVTypography,
} from 'lib/components';
import PropTypes from 'prop-types';
import clsx from 'lib/clsx';
import {
  SUCCESS, ERROR, WARNING, INFO,
} from 'constants/AppConstants';

const useStyles = makeStyles((theme) => ({
  alertContainer: {
    borderRadius: '0px',
    gap: '16px',
    [`&.${SUCCESS}`]: {
      backgroundColor: theme.evPalette.lime[100],
      '& svg': { color: theme.evPalette.lime[700] },
      borderBottom: `1px solid ${theme.evPalette.lime[700]}`,
    },
    [`&.${WARNING}`]: {
      backgroundColor: theme.evPalette.mango[100],
      '& svg': { color: theme.evPalette.mango[700] },
      borderBottom: `1px solid ${theme.evPalette.mango[700]}`,
    },
    [`&.${ERROR}`]: {
      backgroundColor: theme.evPalette.rose[100],
      '& svg': { color: theme.evPalette.rose[900] },
      borderBottom: `1px solid ${theme.evPalette.rose[900]}`,
    },
    [`&.${INFO}`]: {
      backgroundColor: theme.evPalette.ocean[100],
      '& svg': { color: theme.evPalette.ocean[600] },
      borderBottom: `1px solid ${theme.evPalette.ocean[600]}`,
    },
  },
  alertIcon: {
    margin: 0,
  },
  alertMsg: {
    color: theme.evPalette.charcoal[900],
    '&>.title': {
      fontWeight: 600,
      fontSize: '14px',
      lineHeight: '19px',
    },
    '&>.message': {
      fontWeight: 400,
      fontSize: '14px',
      lineHeight: '18px',
      '&>a': {
        color: theme.evPalette.ocean[700],
      },
    },
    '@media (min-width: 1024px)': {
      gap: '8px',
      '&>.title': {
        fontWeight: 600,
        lineHeight: '27px',
      },
      '&>.message': {
        fontWeight: 400,
        lineHeight: '18px',
      },
    },
  },
}));

function Banner(props) {
  const styles = useStyles();
  const {
    severity, handleAlertClose, title, message, className, classes, ...rest
  } = props;

  return (
    <EVAlert
      severity={severity}
      iconMapping={{ success: <EVCheckCircleOutlineIcon /> }}
      onClose={handleAlertClose}
      className={clsx(styles.alertContainer, severity, className)}
      classes={{ message: styles.alertMsg, icon: styles.alertIcon, ...classes }}
      {...rest}
    >
      {title && <EVTypography className="title">{title}</EVTypography>}
      <EVTypography className="message">
        {message}
      </EVTypography>
    </EVAlert>
  );
}

Banner.defaultProps = {
  severity: 'info',
  handleAlertClose: null,
  title: '',
  message: null,
  className: '',
  classes: {},
};

Banner.propTypes = {
  severity: PropTypes.string,
  handleAlertClose: PropTypes.func,
  title: PropTypes.string,
  message: PropTypes.oneOfType([PropTypes.element, PropTypes.string]),
  className: PropTypes.string,
  classes: PropTypes.objectOf(PropTypes.string),
};

export default Banner;
